export default {"src":"/_next/static/media/destination.649bc901.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};